module.exports = __webpack_public_path__ + "static/media/aws_logo.3d280183.png";